import useTheme from '../../hooks/useTheme'

const Liquidity = () => {
  const { theme } = useTheme()
  return (
    <div className='flex flex-col h-screen'>
      <iframe
        className='flex-grow w-full'
        style={{ border: 'none' }}
        src={`https://charts.mongodb.com/charts-sin-nombre-wrerk/public/dashboards/0892f0c2-4331-45f7-8799-c5115b1b81da?theme=${theme}`}
      />
    </div>
  )
}

export default Liquidity
